export const attachShouldCostModel = {
  ATTACH_SKU_NOTE:
    'In case of SKUs with multiple models, model needs to be set as final from SKU Management to reflect on IFA dashboard.',
  GET_SKU_ERROR: 'Failed to load SKUs.',
  ATTACH_MODEL_TO_SKUS_ERROR: 'Failed to attach model to skus!',
  ATTACH_MODEL_SUCCESS: 'Should cost model is created successfully.',
  BREAKDOWN_ERROR: 'Unable to get breakdown for model.',
  NO_SKUS_MESSAGE: 'No SKUs Found for selected filters',
  NO_DATA_FOUND_MESSAGE:'No models found for selected filters',
  BOTTOM_UP_PERCENTAGE_DISABLE_MSG:"% option will be disabled for bottom up models"

}

export const handleNumberKeyDown = (e) => {
  if (
    e.key === 'ArrowUp' ||
    e.key === 'ArrowDown' ||
    e.key === 'e' ||
    e.key === 'E' ||
    e.key === '-' ||
    e.key === '+'
  ) {
    e.preventDefault()
  }
}
